module.exports = __webpack_public_path__ + "img/1-1.e0b25c9d.svg";